import { useState } from 'react';
import { Modal } from './Modal';

type ConfirmProps = {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/** 应用内确认框，替代 window.confirm。 */
export function ConfirmDialog({
  title, message, confirmLabel = '确定', cancelLabel = '取消', danger = false, busy = false, onConfirm, onCancel,
}: ConfirmProps) {
  return (
    <Modal title={title} subtitle={message} onClose={onCancel}>
      <div className="modal-actions">
        <button type="button" className="secondary-button" disabled={busy} onClick={onCancel}>{cancelLabel}</button>
        <button type="button" className={danger ? 'danger-button' : 'primary-button'} disabled={busy} onClick={onConfirm}>
          {busy ? '处理中…' : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}

type PromptProps = {
  title: string;
  label: string;
  initial?: string;
  placeholder?: string;
  confirmLabel?: string;
  required?: boolean;
  busy?: boolean;
  onSubmit: (value: string) => void;
  onCancel: () => void;
};

/** 应用内输入框，替代 window.prompt。 */
export function PromptDialog({
  title, label, initial = '', placeholder, confirmLabel = '确定', required = true, busy = false, onSubmit, onCancel,
}: PromptProps) {
  const [value, setValue] = useState(initial);
  const canSubmit = !required || value.trim().length > 0;
  return (
    <Modal title={title} onClose={onCancel}>
      <form className="device-form" onSubmit={(event) => { event.preventDefault(); if (canSubmit && !busy) onSubmit(value.trim()); }}>
        <label><span>{label}</span><input autoFocus value={value} onChange={(event) => setValue(event.target.value)} placeholder={placeholder} /></label>
        <footer>
          <button type="button" className="secondary-button" disabled={busy} onClick={onCancel}>取消</button>
          <button type="submit" className="primary-button" disabled={!canSubmit || busy}>{busy ? '处理中…' : confirmLabel}</button>
        </footer>
      </form>
    </Modal>
  );
}
